import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelDynamicComponent } from './side-panel-dynamic/side-panel-dynamic.component';

@NgModule({
    declarations: [SidePanelDynamicComponent],
    imports: [CommonModule],
    exports: [SidePanelDynamicComponent]
})
export class SidePanelModule {}
